module.exports = __webpack_public_path__ + "img/msi-giftcard-modal.7f6d2be4.jpg";